export default "__VITE_ASSET__DXtG6Q2z__"